export enum Action {
    SAVE_QUESTIONS = "SaveQuestions",
    SAVE_QUOTE = "SaveQuote",
    SAVE_EMAIL = "SaveEmail",
    SAVE_BUY_PAGE = "SaveBuyPage",
    SAVE_PURCHASE = "SavePurchase",
    SAVE_PURCHASE_ERROR = "SavePurchaseError",
    SAVE_NO_QUOTE = "SaveNoQuote",
    SAVE_ERROR = "SaveError",
    SAVE_CONVERT_ERROR = "SaveConvertError",
    SAVE_SHORTFORM = "ShortForm"
}